import { getAccessToken } from '../utils/session';
import { BASE_URL, UPDATE_ENTITY_MASTER_API } from '../endpoints/apiEndpoints';

export const UpdateEntityList = async updateData => {
  try {
    const token = getAccessToken();
    const apiUrl = `${BASE_URL}/${UPDATE_ENTITY_MASTER_API}`;
    const payload = {
        uuid: updateData.uuid,
        entityName: updateData.entityName.trim(),
        entityPan: updateData.entityPan,
    };

    // Set up request options with authorization header
    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(payload)
    };

    // Make the API request
    const response = await fetch(apiUrl, requestOptions);

    // Handle HTTP errors
    if (!response.ok) {
      // Try to get error details from response if available
      let errorMessage;
      try {
        const errorData = await response.json();
        errorMessage =
          errorData.error || `Request failed with status: ${response.status}`;
      } catch {
        errorMessage = `Request failed with status: ${response.status}`;
      }
      throw new Error(errorMessage);
    }

    // Parse and return the successful response
    const data = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    // Handle network errors or other exceptions
    console.error('Error fetching entity list:');
    return {
      success: false,
      error: error.message || 'Failed to fetch entity list',
    };
  }
}

export default UpdateEntityList;
